export const NullComponent = () => <></>;
